// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.csi-middleware-customView-options-CustomViewOptions-module-container {
	padding-bottom: 12px;
}

.csi-middleware-customView-options-CustomViewOptions-module-galleryContainer {
	padding-bottom: 16px;
}

.csi-middleware-customView-options-CustomViewOptions-module-optionLeft {
	width: 50%;
}

.csi-middleware-customView-options-CustomViewOptions-module-optionRightSelect {
	padding-left: 24px;
	width: 50%;
}

.csi-middleware-customView-options-CustomViewOptions-module-sectionTitle {
	font-size: 14px;
	font-weight: 700;
	line-height: 20px; 
}

.csi-middleware-customView-options-CustomViewOptions-module-tableOptionLeft {
	gap: 4;
	width: 50%;
}

.csi-middleware-customView-options-CustomViewOptions-module-tableOptionRightCheck {
	padding-left: 24px;
	padding-top: 16px;
	width: 50%;
}

.csi-middleware-customView-options-CustomViewOptions-module-tableOptionRightSelect {
	gap: 4;
	padding-left: 24px;
	width: 50%;
}

.csi-middleware-customView-options-CustomViewOptions-module-tableSectionTitle {
	color: var(--Black100);
	font-size: 14px;
	font-weight: 700;
	line-height: 20px;
}

.csi-middleware-customView-options-CustomViewOptions-module-tableSectionTitleContainer {
	padding-bottom: 12px;
}`, "",{"version":3,"sources":["webpack://./src/csi/middleware/customView/options/CustomViewOptions.module.css"],"names":[],"mappings":"AAAA;CACC,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,MAAM;CACN,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,UAAU;AACX;;AAEA;CACC,MAAM;CACN,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,sBAAsB;CACtB,eAAe;CACf,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,oBAAoB;AACrB","sourcesContent":[".container {\n\tpadding-bottom: 12px;\n}\n\n.galleryContainer {\n\tpadding-bottom: 16px;\n}\n\n.optionLeft {\n\twidth: 50%;\n}\n\n.optionRightSelect {\n\tpadding-left: 24px;\n\twidth: 50%;\n}\n\n.sectionTitle {\n\tfont-size: 14px;\n\tfont-weight: 700;\n\tline-height: 20px; \n}\n\n.tableOptionLeft {\n\tgap: 4;\n\twidth: 50%;\n}\n\n.tableOptionRightCheck {\n\tpadding-left: 24px;\n\tpadding-top: 16px;\n\twidth: 50%;\n}\n\n.tableOptionRightSelect {\n\tgap: 4;\n\tpadding-left: 24px;\n\twidth: 50%;\n}\n\n.tableSectionTitle {\n\tcolor: var(--Black100);\n\tfont-size: 14px;\n\tfont-weight: 700;\n\tline-height: 20px;\n}\n\n.tableSectionTitleContainer {\n\tpadding-bottom: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `csi-middleware-customView-options-CustomViewOptions-module-container`,
	"galleryContainer": `csi-middleware-customView-options-CustomViewOptions-module-galleryContainer`,
	"optionLeft": `csi-middleware-customView-options-CustomViewOptions-module-optionLeft`,
	"optionRightSelect": `csi-middleware-customView-options-CustomViewOptions-module-optionRightSelect`,
	"sectionTitle": `csi-middleware-customView-options-CustomViewOptions-module-sectionTitle`,
	"tableOptionLeft": `csi-middleware-customView-options-CustomViewOptions-module-tableOptionLeft`,
	"tableOptionRightCheck": `csi-middleware-customView-options-CustomViewOptions-module-tableOptionRightCheck`,
	"tableOptionRightSelect": `csi-middleware-customView-options-CustomViewOptions-module-tableOptionRightSelect`,
	"tableSectionTitle": `csi-middleware-customView-options-CustomViewOptions-module-tableSectionTitle`,
	"tableSectionTitleContainer": `csi-middleware-customView-options-CustomViewOptions-module-tableSectionTitleContainer`
};
module.exports = ___CSS_LOADER_EXPORT___;
